import { MembershipTierWithAnon } from './types/MembershipTierWithAnon';
import * as gql from './gql';

export type MemberType = 'Anonymous' | gql.typesClient.MembershipTier;
export function getMemberType(tier: MembershipTierWithAnon | null): MemberType {
  if (!tier || tier === 'Anon') return 'Anonymous';
  return tier;
}

export type CurrentUserAnalytics = {
  id: string;
  first_name: string | null;
  last_name: string | null;
  email: string;
  image?: { processed_url: string | null } | null;
  city: string | null;
  country: string | null;
  zip: string | null;
  state: string | null;
  address: string | null;
  company: string | null;
  phone: string | null;
  class_intensity?: Array<{ id: string }> | null;
  class_level?: Array<{ id: string }> | null;
  interests?: Array<{ id: string }> | null;
  user_goals?: Array<{ id: string }> | null;
  purchased_course_ids?: string[];
};

export function makeUserAnalyticsData(
  currentUser: CurrentUserAnalytics | null,
  tier: MembershipTierWithAnon | null,
) {
  const memberType = getMemberType(tier);
  if (!currentUser) return { memberType };

  return {
    ...currentUser,
    userId: currentUser.id,
    memberType,
    member_type: memberType,

    address: {
      city: currentUser.city || '',
      country: currentUser.country || '',
      postalCode: currentUser.zip || '',
      state: currentUser.state || '',
      street: currentUser.address || '',
    },

    firstName: currentUser.first_name || '',
    lastName: currentUser.last_name || '',
    company: { name: currentUser.company || '' },
    company_slug: currentUser.company || null,
    phone: currentUser.phone || '',

    image: currentUser.image?.processed_url || null,
    class_intensity: currentUser?.class_intensity?.map(item => item.id).join(';') || null,
    class_level: currentUser?.class_level?.map(item => item.id).join(';') || null,
    interests: currentUser?.interests?.map(item => item.id).join(';') || null,
    user_goals: currentUser?.user_goals?.map(item => item.id).join(';') || null,

    // Send purchased courses to Segment -> HubSpot, to power welcome emails, etc.
    courses:
      currentUser?.purchased_course_ids?.map(courseId => `course_${courseId}`).join(';') || null,
  };
}
